package de.katoonerie.content

import androidx.compose.runtime.Composable
import app.softwork.routingcompose.NavLink
import de.katoonerie.contentful.NavigationBar
import de.katoonerie.util.withHash
import de.katoonerie.util.withPreview
import org.jetbrains.compose.web.attributes.AttrsScope
import org.jetbrains.compose.web.css.backgroundColor
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Img
import org.w3c.dom.HTMLDivElement
import org.w3c.dom.HTMLImageElement

@Composable
fun NavigationBar.NavigationBar(
    preview: Boolean = false,
    tileIconAttrs: (AttrsScope<HTMLDivElement>.() -> Unit)? = null,
    tileImageAttrs: (AttrsScope<HTMLImageElement>.() -> Unit)? = null
) {
    Div(attrs = { classes("flex", "flex-wrap", "flex-row", "justify-center", "mb-6") }) {
        items.forEach { item ->
            NavigationItem(page, item, preview, tileIconAttrs, tileImageAttrs)
        }
    }
}

@Composable
private fun NavigationItem(
    page: NavigationBar.Page,
    item: NavigationBar.Item,
    preview: Boolean,
    tileIconAttrs: (AttrsScope<HTMLDivElement>.() -> Unit)? = null,
    tileImageAttrs: (AttrsScope<HTMLImageElement>.() -> Unit)? = null
) {
    if (page.path.isBlank()) {
        A(href = page.path.withHash(item.tile.hash)) { TileIcon(page, item, tileIconAttrs) }
    } else {
        NavLink(to = page.path.withPreview(preview).withHash(item.tile.hash)) {
            TileIcon(
                page,
                item,
                tileIconAttrs,
                tileImageAttrs
            )
        }
    }
}

@Composable
private fun TileIcon(
    page: NavigationBar.Page,
    item: NavigationBar.Item,
    attrs: (AttrsScope<HTMLDivElement>.() -> Unit)? = null,
    imageAttrs: (AttrsScope<HTMLImageElement>.() -> Unit)? = null
) {
    Div(attrs = {
        style { backgroundColor(item.color) }
        if (attrs != null) {
            attrs.invoke(this)
        } else {
            classes("w-24", "h-16", "px-2", "mb-10")
        }
        title("${page.title}: ${item.tile.title}")
    }) {
        Img(src = item.iconUrl.toString(), attrs = {
            if (imageAttrs != null) {
                imageAttrs.invoke(this)
            } else {
                classes("pt-10", "max-h-[90px]", "mx-auto")
            }
        })
    }
}
